import { serviceMaker, methods, api } from "@/http/index.js";

export const getQuestionDetails = (id) =>
  serviceMaker(`/feedback-questions/${id}`, methods.GET, api.NGB);
export const getQuestionListById = (id, isSelfcare) =>
  serviceMaker(`/feedback-questions/subcategory/${id}?isSelfcareUser=${isSelfcare}`, methods.GET, api.NGB);
export const getQnAList = () =>
  serviceMaker(`/feedback-questions/stats?page=0&size=1000`, methods.GET, api.NGB);
export const deleteQuestion = (id) =>
  serviceMaker(`/feedback-questions/${id}`, methods.DELETE, api.NGB);
export const createQuestions = (data) =>
  serviceMaker(`/feedback-questions`, methods.POST, api.NGB, data);
export const editQuestions = (id, data) =>
  serviceMaker(`/feedback-questions/${id}`, methods.PUT, api.NGB, data);


export const getFeedbackQuesList = () =>
  serviceMaker(`/feedback/ticket`, methods.GET, api.NGB);
export const getFeedbackDetailsById = (id) =>
  serviceMaker(`/feedback-questions/ticket/${id}/responses`, methods.GET, api.NGB);
export const getFeedbackDetailsByCampaignId = (id, campaignId) =>
  serviceMaker(`/feedback-questions/ticket/${id}/${campaignId}/responses`, methods.GET, api.NGB);